import React, { createContext, useContext } from 'react';
import { PageDoc } from '../types/page-builder.types';

export interface ViewRenderContextValue {
  viewId: string;
  /** Full page document, for config-time enumeration of bindable blocks. */
  pageDoc?: PageDoc;
}

const ViewRenderContext = createContext<ViewRenderContextValue>({ viewId: '' });

export const ViewRenderProvider: React.FC<
  React.PropsWithChildren<ViewRenderContextValue>
> = ({ viewId, pageDoc, children }) => (
  <ViewRenderContext.Provider value={{ viewId, pageDoc }}>{children}</ViewRenderContext.Provider>
);

export const useViewRender = (): ViewRenderContextValue => useContext(ViewRenderContext);
